export enum DocumentViewMode {
  teacher = "teacher",
  student = "student",
  compare = "compare",
  review = "review",
  submit = "submit",
}
